import React from 'react';
import { KalpStudioIcon } from '../../assets/svg';
import './Footer.scss';

const Footer = () => {

  const handleRedirect = () => {
      window.open(process.env.REACT_APP_KALP_STUDIO_URL, '_blank');
  };

  return (
    <div className="footer-main">
      <div className="footer-left-side">
        KALP Explorer © {new Date().getFullYear()}  | Powered by
      </div>
      <div onClick={handleRedirect} className="footer-right-side">
        <KalpStudioIcon />
      </div>
    </div>
  )
}

export default Footer;
